<template>
    <div class="Register mx-auto my-2">
        <Nav></Nav>
        <div id="loading" v-if="showLoading">
            <img
            class="loadingImg"
            src="../../assets/images/loading.gif"
            alt="loading..."
            width="200"
            />
        </div>
        <div class="my-2">
            <p>請登入會員Email會員資料已完成Line綁定</p>
            <p>綁定後，可操作訂單及HiQuiz頁面</p>
        </div>
        <!-- 學員頭貼 -->
        <div class="d-flex mb-2">
            <img class="userPhoto mx-auto" :src="profile.pictureUrl" v-if="profile.pictureUrl"/>
        </div>
        <!-- 輸入會員資料  -->
        <div class="RegisterForm Form">
            <div class="d-flex my-2">
                <span style="color:red;font-weight: bold;">*</span>
                <span class="subtitle">姓 名：</span>
                <input type="text" class="flex-fill" v-model="name"/>
            </div>
            <div class="d-flex my-2">
                <span style="color:red;font-weight: bold;">*</span>
                <span class="subtitle">Email：</span>
                <input type="text"  class="flex-fill" v-model="email"/>
            </div>
            <div class="d-flex my-2">
                <span style="color:red;font-weight: bold;">*</span>
                <span class="subtitle">性 別：</span>
                <div >
                    <input type="radio" class="mx-2" name="gender" value="1" v-model="gender" />
                    <label class="mx-2">男</label>
                </div>
                <div>
                    <input type="radio" class="mx-2" name="gender" value="2" v-model="gender" />
                    <label class="mx-2">女</label>
                </div>
            </div>
            <TelVerificationCheck :telVerList="telVerList" @update:telVerList="handletelVerListChange"></TelVerificationCheck> 
            <div class="d-flex flex-column my-2">
                <div>
                    <span style="color:red;font-weight: bold;">*</span>
                    <span class="subtitle ">最想要</span>
                </div>
                <select name="WantThing" v-model="WantTing">
                    <option value="" disabled selected hidden>-- 請選擇想諮詢的項目 --</option>
                    <option v-for="item in WantThingList" :value="item.value">{{item.value}}</option>
                </select>
            </div>
            <div class="d-flex flex-column my-2">
                <div>
                    <span style="color:red;font-weight: bold;">*</span>
                    <span class="subtitle ">最想去</span>
                </div>
                <select name="Country" v-model="Country">
                    <option value="" disabled selected hidden>-- 請選擇最想去的國家 --</option>
                    <option v-for="item in CountryList" :value="item.value">{{item.value}}</option>
                </select>
            </div>
            <div class="d-flex flex-column my-2">
                <div>
                    <span style="color:red;font-weight: bold;">*</span>
                    <span class="subtitle">諮詢辦公室</span>
                </div>
                <select name="Office" v-model="Office">
                    <option value="" disabled selected hidden>-- 請選擇諮詢辦公室 --</option>
                    <option v-for="item in OfficeList" :value="item.value">{{item.value}}</option>
                </select>
            </div>
        </div>
        <PrivacyPolicy @update:agree="handleAgree"></PrivacyPolicy>
        <div class="my-3">
            <div class="btn RegisterBtn" @click="BeforeCheck()">送出</div>
        </div>
    </div>
</template>

<script>
import Nav from '@/components/Nav'
import TelVerificationCheck from '@/components/LineComponents/TelVerificationCheck'
import PrivacyPolicy from '@/components/LineComponents/PrivacyPolicy'

import {app} from '@/main'
import Vue from 'vue'
import axios from 'axios'
// import moment from 'moment'

export default {
    name: 'Register',
    components:{
        Nav,TelVerificationCheck,PrivacyPolicy
    },
    data () {
        return {
            showLoading:'',
            AccessToken:'',
            ProviderUserId:'',
            profile:null,
            Token:'',
            WantThingList:[],
            OfficeList:[],
            CountryList:[],
            WantTing:'',
            Office:'',
            Country:'',
            name:'',
            email:'',
            gender:'',
            phone:'',
            agreePolicy:false,
            telVerList:{
                phone:'',
                TelCkeck:'',
                VerificationCode:'',
                phoneCode:'',
                phoneCodeDisplayName:'',
            },
        }
    },
    methods:{
        GetRegisterData(){
            this.showLoading = true;

            //登入驗證-輸入email及密碼
            const api =`${process.env.APIPATH}/api/Member/GetRegisterData`;
            const inputdata = {};

            axios.post(api, inputdata)
                .then((response) => {
                    this.showLoading = false;
                    if(response.data.isSuccess){ 
                        this.WantThingList = response.data.wantThings;
                        this.CountryList = response.data.country;
                        this.OfficeList = response.data.office;
                    }
                })
                .catch(error => {
                    this.showLoading = false;
                    this.errorMessage = error.message;
                    console.error("There was an error!", error);
                });
        },
        handleAgree(type){
            this.agreePolicy = type;
        },
        handletelVerListChange(newList){
            this.telVerList = newList;
            // console.log('newList',newList)
        },
        validateString(str) {
            const regex = /^[a-zA-Z0-9\u4e00-\u9fa5\s]+$/; // 正则表达式
            return regex.test(str); // 测试字符串是否符合要求
        },
        BeforeCheck(){
            if(this.name == ''){
                alert('請輸入姓名');
            }else if(!this.validateString(this.name)){
                alert("姓名僅可輸入中文、英文、數字")
            }else if(this.email == ''){
                alert('請輸入Email');
            }else if(this.gender == ''){
                alert('請輸入性別');
            }else if(this.WantTing == ''){
                alert('請選擇最想諮詢的項目');
            }else if(this.Country == ''){
                alert('請選擇最想去的國家');
            }else if(this.Office == ''){
                alert('請選擇諮詢辦公室');
            }else if(!this.agreePolicy){ //沒有同意隱私權政策
                alert('請先同意隱私權政策');
            }else if(!this.telVerList.TelCkeck){ //電話驗證碼錯誤
                alert('驗證碼錯誤');
            }else{ //可送出
                this.CheckVerification();
            }
        },
        //驗證 驗證碼
        CheckVerification(){
            this.showLoading = true;

            const api =`${process.env.APIPATH}/api/Member/CheckVerification`;
            const inputdata = 
            {
                "Phone":this.telVerList.phone,
                "ContactType":1,
                "VerificationCode":parseFloat(this.telVerList.VerificationCode),
            };

            axios.post(api, inputdata)
                .then((response) => {
                    this.showLoading = false;
                    if(response.data.isSuccess){ 
                        //驗證成功
                        this.RegisterUserData()
                    }else{
                        //驗證失敗
                        console.error(response.data.message);
                        alert(response.data.message);
                    }
                })
                .catch(error => {
                    this.showLoading = false;
                    this.errorMessage = error.message;
                    console.error("There was an error!", error);
                });
        },
        //送出
        RegisterUserData(){
            this.showLoading = true;
            //登入驗證-輸入email及密碼
            const api =`${process.env.APIPATH}/api/Member/RegisterUserData`;
            const inputdata = {
                "Name":this.name,
                "Email":this.email,
                "Gender":this.gender,
                "phonecode":this.telVerList.phoneCode,
                "phonecodedisplayname":this.telVerList.phoneCodeDisplayName,
                "Phone":this.telVerList.phone,
                "Service":this.WantTing,
                "Country":this.Country,
                "Office":this.Office,
                "ProviderUserId":this.ProviderUserId,
                "ProviderId":1,
                "AccessToken":this.AccessToken,
            };

            axios.post(api, inputdata)
                .then((response) => {
                    this.showLoading = false;
                    if(response.data.isSuccess){
                        //跳至註冊完成頁
                        this.$router.push({
                            name: 'FinishRegister',
                        });
                    }else{
                        console.log(response.data.message)

                    }
                })
                .catch(error => {
                    this.showLoading = false;
                    this.errorMessage = error.message;
                    console.error("There was an error!", error);
                });

        },
    },
    created(){
        this.GetRegisterData();
        this.AccessToken = sessionStorage.getItem('AccessToken');
        this.profile = JSON.parse(sessionStorage.getItem('profile'))
        this.DecodedIDToken = JSON.parse(sessionStorage.getItem('DecodedIDToken'))
        this.ProviderUserId = this.profile.userId;
        this.name = this.profile.displayName;
        this.email = this.DecodedIDToken.email;
    },
}
</script>




// WEBPACK FOOTER //
// src/components/line/Register.vue